import { render, staticRenderFns } from "./bank-detail.vue?vue&type=template&id=27b09c5e"
import script from "./bank-detail.vue?vue&type=script&lang=js"
export * from "./bank-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports